import React from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';


const useStyles = makeStyles((theme)=>({

  orderSuccessBlock:{
    padding:'400px 0 100px 0',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  row:{
    maxWidth:'400px', 
    margin:'0 auto', 
  },
  orderSuccessH1:{
    fontSize:'35px', 
    textAlign:'center', 
    padding:'0 0 40px 0'
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center'
  },
  leftBtn:{
    width:'200px',
    height:'50px',
    borderRadius:'5px',
    background:'#007235',
    color:'#fff',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  rightBtn:{
    width:'100px',
    height:'50px',
    borderRadius:'5px',
    background:'#fff',
    border:'1px solid #007235',
    color:'#007235',
    marginLeft:'10px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
}))


const RegisterSuccess = () => {

  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.orderSuccessBlock}>
      <div className={classes.row}>
        <h1 className={classes.orderSuccessH1}>
            회원가입이
        </h1>
        <h1 className={classes.orderSuccessH1}>
            완료 되었습니다.
        </h1>
        <h1 className={classes.orderSuccessH1}>
            로그인을 해주세요!
        </h1>
  
        <div className={classes.btnDiv}>
          <div>
            <Link to="/Login">
                <button className={classes.leftBtn}>로그인하러 가기</button>
            </Link>
          </div>

        </div>

      </div>
    </div>
  )
}

export default RegisterSuccess
